import moment from 'moment';
import { IEventFilter, ICalendarState } from '../classes/calendar';
import filter from '../components/filters-ace/filter';
import { upsertEventFilter } from '../redux-state/actions/calendar.actions';
import { Store, Dispatch } from 'redux';
import { getMonthElement, scrollToMonth, removeLoader } from './scroll-to-month';
import { IOption } from '../interfaces/option';
import { IEvent } from '../interfaces/event';
import { forEach } from 'lodash';


export function AddFilterToQuery(eventFilters: Array<IEventFilter>): void {
    const serialized = serializeProps(eventFilters);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let queryString :string[] = [];
    for (var event of eventFilters) {
        queryString.push(encodeURI(event.key + "=" + event.selectedValue));
    }
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?"+queryString.join("&");
    if (window.location.href.split("#").length > 1) {
        newurl+= "#"+window.location.href.split("#")[1];
    }
    window.history.pushState({ path: newurl }, '', newurl);

}

export function GetFilterFromQuery(search: string, filterOptions: Array<IOption>,
    filterToGet: string, lastLoadedMonth: moment.Moment, selectFiltersFunction: (filter, shouldUpdateQuery) => any, goToMonthFunction: (toMonth) => any): void {
    // Remove hash added for Month scrolling
    if (search.substr(1).length > 0) {
        let queries = decodeURI(search.substr(1)).split('&');

        let matchedQuery = queries.filter(q => q.indexOf(filterToGet) == 0)[0];

        if (matchedQuery) {
            let value = matchedQuery.split('=')[1];

            selectFiltersFunction(value, false);

            const matchedFilter = filterOptions.filter(o => o.value === value)[0];

            if (matchedFilter) {
                const firstOccuranceDate = matchedFilter.firstOccurance;

                // If a month is 
                if (firstOccuranceDate) {
                    const toMonth = moment(firstOccuranceDate);

                    // Only change months if it's in the future.
                    if (toMonth.isAfter(lastLoadedMonth)) {
                        goToMonthFunction(toMonth);
                        let scrollInterval = setInterval(() => {
                            const monthElement = getMonthElement(toMonth);

                            if (monthElement) {
                                removeLoader();
                                if (scrollToMonth(toMonth)) {
                                    clearInterval(scrollInterval);
                                }
                            }
                        }, 500);
                    } else {
                        // If the month has already loaded, apply filter and remove the loader.
                        // We need a timeout because even though the data is cached, a Promise object is created.
                        //setTimeout(() => removeLoader(), 500);
                        let scrollInterval = setInterval(() => {
                            const monthElement = getMonthElement(toMonth);

                            if (monthElement) {
                                removeLoader();
                                if (scrollToMonth(toMonth)) {
                                    clearInterval(scrollInterval);
                                }
                            }
                        }, 500);
                    }

                } else {
                    // If the month has already loaded, apply filter and remove the loader.
                    // We need a timeout because even though the data is cached, a Promise object is created.
                    setTimeout(() => removeLoader(), 500);
                }
            }
        }

    }
}

function serializeProps(eventFilter: Array<IEventFilter>): string {
    if (eventFilter.length < 1)
        return "";

    return "?" + eventFilter.map(filter => filter.key + "=" + filter.selectedValue).join("&");
}


export function generateEventFilter(propertyToFilter: string, selectedValue: string) {
    return (event: IEvent) => {
        const propertyValue = event[propertyToFilter];
        // If it's an array, check if the value exists inside
        if (propertyValue.constructor === Array) {
            return (propertyValue as any[]).some(item => item === selectedValue);
        } else {
            return event[propertyToFilter] === selectedValue
        }
    }
}
